import React, { FC } from 'react'
import { makeStyles } from '@material-ui/core/styles'
import HandleMarkup from '@src/components/HandleMarkup'
import { Faq } from '@src/types/graphql-types'
import { Typography } from '@material-ui/core'
import vrStyles, { getVerticalRhythm } from '@src/styles/utils/vrStyles'

const { vr1 } = vrStyles

export const useStyles = makeStyles(() => {
  return {
    vr1,
    itemWrapper: getVerticalRhythm(6),
  }
})

interface ProductFAQItemProps {
  faq: Faq
}

const ProductFAQItem: FC<ProductFAQItemProps> = ({ faq }) => {
  const classes = useStyles()

  return (
    <div className={classes.itemWrapper}>
      <Typography variant="body1" component="h3" className={classes.vr1}>
        <HandleMarkup value={faq.question} />
      </Typography>
      <Typography variant="body2" component="p">
        <HandleMarkup value={faq.answer} />
      </Typography>
    </div>
  )
}

export default ProductFAQItem
